module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag41_1967AT.c6c6b225.jpg";